export const getMobileFontSizeClassName = (fontSize) => `mf-${fontSize}`;
//# sourceMappingURL=get-mobile-font-size-class-name.js.map